module.exports = __webpack_public_path__ + "static/depoimento14-12e10465a995cbf7bbf12ebcbb686baa.png";